<template>
  <div class="container">
    <h1>Texts</h1>
    <div class="bg-light border rounded p-4 mb-4">
      <p>Quiz Boxing texts can be edited directly from this interface.</p>
      <p>
        The label shown in
        <span class="font-weight-bold text-primary">blue</span> is the text
        written in the application. This text will be replaced by the editable
        text.
      </p>
      <p>
        The fields between <code>{</code> and <code>}</code> are variables that
        can be adapted according to context. They can be used in texts.<br />
        Example: <code>{username}</code> is the name of the logged-in user.<br />
      </p>
      <p>
        Some fields contain HTML code. It can be identified by the symbols
        <code>&lt;</code> and <code>&gt;</code>. This code is used to format the
        text. It's best to leave them in to maintain the basic formatting.<br />
        Example: <code>&lt;strong&gt;TEXT&lt;/strong&gt;</code> makes the text
        bold.
      </p>
      <p>
        Line break characters may appear in texts. They are identified by the
        symbol <code>\n</code> or <code>\r</code>.<br />
        Example: <code>\r</code> sets a new line.
      </p>
      <hr />
      <p>
        <span class="font-weight-bold"
          >Don't forget to save your changes when you're done!</span
        ><br />
        Once updated, rooms will automatically download the new texts when they
        are restarted.
      </p>
    </div>

    <div class="locales-form-wrapper">
      <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
        <b-form-group
          v-for="(value, index) in contentFlat"
          :key="index"
          :id="index"
          :label="index"
          :label-for="index"
          label-size="lg"
        >
          <b-form-textarea
            id="input-horizontal"
            v-model="contentFlat[index]"
            rows="1"
            max-rows="5"
          ></b-form-textarea>
        </b-form-group>

        <div class="actions">
          <!-- <b-button type="reset" variant="danger">Réinitialiser</b-button> -->
          <b-button type="submit" variant="primary" size="md" class="ml-2 px-4">
            <b-icon-check></b-icon-check> Save
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { BIconCheck } from 'bootstrap-vue'

  export default {
    name: 'Locales',
    components: {
      BIconCheck,
    },
    computed: {
      headers() {
        return {
          'X-PS': this.ps,
        }
      },
    },
    mounted() {
      this.ps = localStorage.getItem('ps')

      this.loadLocale()
    },
    data() {
      return {
        token: null,

        locale: 'en',
        content: null,
        contentFlat: null,
      }
    },
    methods: {
      loadLocale() {
        axios
          .get('/locale/' + this.locale, {
            headers: this.headers,
          })
          .then((response) => {
            console.log(response.data)
            this.content = response.data
            this.contentFlat = this.flattenObject(response.data)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      saveLocale() {
        let payload = {
          content: this.unflatObject(this.contentFlat),
        }
        axios
          .put('/locale/' + this.locale, payload, {
            headers: this.headers,
          })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Texts saved',
              text: 'The texts have been updated.',
            })
          })
          .catch((error) => {
            console.log(error)

            this.$notify({
              type: 'danger',
              title: 'Error',
              text: 'An error occurred while saving the texts. Please try again.',
            })
          })
      },

      onSubmit() {
        console.log('onSubmit')
        console.log(this.contentFlat)
        console.log(this.unflatObject(this.contentFlat))

        this.saveLocale()
      },
      onReset() {
        console.log('onReset')
        console.log(this.content)
      },

      flattenObject(obj, parent, res = {}) {
        for (const key of Object.keys(obj)) {
          const propName = parent ? parent + '.' + key : key
          if (typeof obj[key] === 'object') {
            this.flattenObject(obj[key], propName, res)
          } else {
            res[propName] = obj[key]
          }
        }
        return res
      },

      unflatObject(obj = {}) {
        const result = {}
        let temp, substrings, property, i
        for (property in obj) {
          substrings = property.split('.')
          temp = result
          for (i = 0; i < substrings.length - 1; i++) {
            if (!(substrings[i] in temp)) {
              if (isFinite(substrings[i + 1])) {
                temp[substrings[i]] = []
              } else {
                temp[substrings[i]] = {}
              }
            }
            temp = temp[substrings[i]]
          }
          temp[substrings[substrings.length - 1]] = obj[property]
        }
        return result
      },
    },
  }
</script>

<style>
  .locales-form-wrapper form label {
    color: var(--blue);
    font-weight: bold;
  }

  .locales-form-wrapper .actions {
    position: fixed;
    bottom: 50px;
    right: 50px;
  }
</style>
